import { render } from "./textMessage.vue?vue&type=template&id=f2ab36ca&scoped=true"
import script from "./textMessage.vue?vue&type=script&lang=js"
export * from "./textMessage.vue?vue&type=script&lang=js"

import "./textMessage.vue?vue&type=style&index=0&id=f2ab36ca&lang=scss&scoped=true"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ab36ca"]])

export default __exports__